import { __assign, __rest } from "tslib";
import React, { forwardRef, useContext } from 'react';
import { Context } from './Formbot';
var PureInput = React.memo(function (_a) {
    var Component = _a.Component, props = __rest(_a, ["Component"]);
    return React.createElement(Component, __assign({}, props));
});
function EasyInput(_a) {
    var name = _a.name, Component = _a.Component, _b = _a.shouldRenderError, shouldRenderError = _b === void 0 ? true : _b, props = __rest(_a, ["name", "Component", "shouldRenderError"]);
    var state = useContext(Context);
    if (!state) {
        return React.createElement(PureInput, __assign({ name: name, Component: Component }, props));
    }
    var value = name && state.values[name];
    var defaultValue = Component.defaultProps && Component.defaultProps.defaultValue !== undefined
        ? Component.defaultProps.defaultValue
        : '';
    return (React.createElement(PureInput, __assign({ name: name, value: value !== undefined ? value : defaultValue, error: shouldRenderError && name ? state.errors[name] : undefined, onChange: state.onChange, onBlur: state.onBlur, onFocus: state.onFocus, Component: Component }, props)));
}
export function createEasyInput(Component) {
    return forwardRef(function (props, ref) {
        return React.createElement(EasyInput, __assign({ Component: Component, forwardedRef: ref }, props));
    });
}
//# sourceMappingURL=EasyInput.js.map